import * as React from 'react'

const WindIcon = props => (
  <svg
    width="17"
    height="11"
    viewBox="0 0 17 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.3696 5.77269C16.3776 6.09827 16.2736 6.42385 16.0976 6.69385C15.8175 7.11472 15.3295 7.41647 14.7454 7.41647H4.06386C3.43177 7.41647 2.83969 7.05119 2.59165 6.46355C2.49564 6.24915 2.43963 6.01886 2.41563 5.77269C2.39962 5.62181 2.39162 5.47093 2.39962 5.32005C2.45563 4.08126 3.25575 2.85041 4.45592 3.01717C4.45592 3.01717 4.45592 3.01717 4.46392 3.01717C4.44792 2.84247 4.44792 2.66776 4.47192 2.49306C4.75996 0.182235 8.35248 -1.18362 9.94471 1.39721C10.0727 1.60367 10.1847 1.8419 10.2888 2.09601C11.889 0.571343 14.6734 2.14366 14.1533 4.23214C13.8013 5.62975 13.8013 5.62975 14.1533 4.23214C15.0894 4.09714 15.7215 4.41478 16.0816 4.89124C16.2656 5.17712 16.3616 5.47887 16.3696 5.77269Z"
      fill="#EDEDED"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.048 2.73603C10.024 3.01397 9.95203 3.3316 9.69599 3.45072C9.47996 3.55395 9.21592 3.45866 9.00789 3.32366C8.80786 3.18867 8.62384 3.02191 8.3918 2.95044C7.93574 2.81544 7.46367 3.1172 7.11162 3.44278C6.75957 3.76836 6.40752 4.14953 5.93545 4.21306C5.51139 4.27658 5.07133 4.04629 4.80729 3.71277C4.64727 3.50631 4.53525 3.26808 4.46324 3.01397C4.46324 3.01397 4.46324 3.01397 4.47124 3.01397C4.23121 0.40138 8.24778 -1.36946 9.94403 1.394C10.048 1.8387 10.08 2.29134 10.048 2.73603Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.93032 4.60827C5.68229 4.83856 5.25822 4.71944 4.95418 4.86238C4.54612 5.05296 4.49011 5.61677 4.17007 5.93441C3.83402 6.26793 3.24194 6.25205 2.86588 5.96618L2.85788 5.95824C2.51383 5.70412 2.37781 5.26737 2.45782 4.8465C2.66585 3.79035 3.40996 2.87713 4.45811 3.02007C4.45811 3.02007 4.45811 3.02007 4.46611 3.02007C4.45011 2.84537 4.45011 2.67067 4.47411 2.50391C5.0982 2.61508 5.66628 3.02007 5.94632 3.58388C6.02633 3.73476 6.08234 3.90152 6.09835 4.07622C6.11435 4.27475 6.07434 4.48121 5.93032 4.60827Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.90177 0.584522C7.82976 0.457466 7.70174 0.378057 7.54971 0.378057C7.18966 0.370116 6.82161 0.40188 6.50957 0.576582C6.41355 0.632169 6.31754 0.703637 6.28553 0.80687C6.26953 0.854516 6.26953 0.902162 6.26953 0.949808C6.26953 1.05304 6.29353 1.16421 6.36554 1.24362C6.42955 1.31509 6.54157 1.34686 6.63758 1.34686C6.7336 1.33892 6.82961 1.29921 6.91762 1.24362C6.98163 1.20392 7.03764 1.14833 7.09365 1.10863C7.20567 1.02922 7.33368 0.973631 7.4697 0.949808C7.58172 0.925985 7.69374 0.918044 7.78975 0.862457C7.88576 0.80687 7.95777 0.679814 7.90177 0.584522Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.8251 1.39062C5.76109 1.39062 5.69709 1.40651 5.64908 1.44621C5.54506 1.52562 5.46505 1.6368 5.41704 1.75591C5.38504 1.82738 5.36904 1.90679 5.37704 1.9862C5.38504 2.06561 5.43305 2.13708 5.50506 2.17678C5.56107 2.20061 5.62507 2.20061 5.68108 2.19267C5.88111 2.1609 6.05714 2.01796 6.12915 1.82738C6.16115 1.74797 6.16915 1.66856 6.15315 1.58915C6.12915 1.47798 6.02513 1.40651 5.91312 1.39857L5.8251 1.39062Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.0572 3.42187C3.76916 3.46952 3.49712 3.61246 3.3211 3.84275C3.16907 4.04127 3.05706 4.2795 3.01705 4.53361C3.00905 4.60508 3.00105 4.70037 3.06506 4.74802C3.09706 4.77978 3.14507 4.77978 3.19308 4.78772C3.26509 4.79567 3.3451 4.79567 3.40911 4.7639C3.52113 4.70831 3.56113 4.58126 3.60914 4.47009C3.69715 4.2398 3.84917 4.00157 4.08121 3.92216C4.09721 3.91422 4.11321 3.91422 4.12921 3.90627C4.21723 3.88245 4.28924 3.82686 4.32924 3.74745C4.42526 3.55687 4.23323 3.39011 4.0572 3.42187Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.637 2.26097C10.573 2.30862 10.517 2.36421 10.477 2.43567C10.445 2.4992 10.429 2.57067 10.453 2.64214C10.509 2.8089 10.709 2.8089 10.837 2.74537C10.949 2.68979 11.037 2.58655 11.1331 2.51508C11.2931 2.38803 11.4931 2.3245 11.6851 2.26891C11.7491 2.25303 11.8132 2.23715 11.8612 2.19744C11.9092 2.15774 11.9412 2.08627 11.9172 2.02274C11.8852 1.95922 11.8052 1.94333 11.7411 1.93539C11.5171 1.91157 11.2851 1.94333 11.0851 2.03068L10.981 2.07039C10.869 2.11803 10.741 2.18156 10.637 2.26097Z"
      fill="white"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.263 4.89193C14.415 4.88399 14.575 4.88399 14.7191 4.89988C14.9831 4.9237 15.2471 5.02693 15.4152 5.22546C15.8792 5.7575 15.5192 6.55954 14.8951 6.74219C14.6311 6.8216 14.359 6.8216 14.079 6.81366C13.7189 6.79777 13.3429 6.75013 13.0388 6.55954C12.6308 6.28955 12.4867 5.67809 12.8708 5.32075C13.0148 5.18575 13.2148 5.11428 13.4149 5.0587C13.6869 4.97929 13.975 4.91576 14.263 4.89193Z"
      fill="#CBBEBB"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.4134 5.7221C11.2694 5.79357 11.1414 5.88886 11.0774 5.98415C11.0134 6.0715 11.0374 6.17473 11.0694 6.27002C11.0934 6.34149 11.1254 6.41296 11.1814 6.46061C11.3414 6.61149 11.7095 6.60355 11.8855 6.49237C12.0375 6.40502 12.1575 6.16679 12.1255 5.99209C12.1095 5.87298 11.9975 5.74592 11.9015 5.68239C11.7735 5.61092 11.5814 5.64269 11.4134 5.7221Z"
      fill="#CBBEBB"
    />
    <path
      d="M7.42002 7.76645H1.48317C1.33114 7.76645 1.20312 7.63939 1.20312 7.48851C1.20312 7.33763 1.33114 7.21058 1.48317 7.21058H7.42002C7.72406 7.21058 7.9801 6.96441 7.9801 6.65471C7.9801 6.34501 7.73206 6.09884 7.42002 6.09884H7.20399C7.05196 6.09884 6.92395 5.97178 6.92395 5.8209C6.92395 5.67003 7.05196 5.54297 7.20399 5.54297H7.42002C8.0361 5.54297 8.54018 6.04325 8.54018 6.65471C8.53218 7.27411 8.0361 7.76645 7.42002 7.76645Z"
      fill="#75BEEA"
    />
    <path
      d="M5.60989 6.74619H0.649181C0.497159 6.74619 0.369141 6.61914 0.369141 6.46826C0.369141 6.31738 0.497159 6.19033 0.649181 6.19033H5.60989C5.84193 6.19033 6.02595 5.99974 6.02595 5.7774C6.02595 5.54711 5.84193 5.36446 5.60989 5.36446H5.24984C5.09782 5.36446 4.9698 5.23741 4.9698 5.08653C4.9698 4.93565 5.09782 4.80859 5.24984 4.80859H5.60989C6.14597 4.80859 6.58603 5.24535 6.58603 5.7774C6.58603 6.30944 6.14597 6.74619 5.60989 6.74619Z"
      fill="#75BEEA"
    />
    <g opacity="0.5">
      <path
        d="M5.60989 6.74619H0.649181C0.497159 6.74619 0.369141 6.61914 0.369141 6.46826C0.369141 6.31738 0.497159 6.19033 0.649181 6.19033H5.60989C5.84193 6.19033 6.02595 5.99974 6.02595 5.7774C6.02595 5.54711 5.84193 5.36446 5.60989 5.36446H5.24984C5.09782 5.36446 4.9698 5.23741 4.9698 5.08653C4.9698 4.93565 5.09782 4.80859 5.24984 4.80859H5.60989C6.14597 4.80859 6.58603 5.24535 6.58603 5.7774C6.58603 6.30944 6.14597 6.74619 5.60989 6.74619Z"
        fill="white"
      />
    </g>
    <path
      d="M6.7826 10.1622H6.42255C6.27052 10.1622 6.14251 10.0352 6.14251 9.88428C6.14251 9.7334 6.27052 9.60634 6.42255 9.60634H6.7826C7.01463 9.60634 7.19866 9.41576 7.19866 9.19341C7.19866 8.97106 7.01463 8.78048 6.7826 8.78048H0.709728C0.557706 8.78048 0.429688 8.65342 0.429688 8.50254C0.429688 8.35167 0.557706 8.22461 0.709728 8.22461H6.7826C7.31868 8.22461 7.75874 8.66136 7.75874 9.19341C7.75874 9.72545 7.31868 10.1622 6.7826 10.1622Z"
      fill="#75BEEA"
    />
    <g opacity="0.5">
      <path
        d="M6.7826 10.1622H6.42255C6.27052 10.1622 6.14251 10.0352 6.14251 9.88428C6.14251 9.7334 6.27052 9.60634 6.42255 9.60634H6.7826C7.01463 9.60634 7.19866 9.41576 7.19866 9.19341C7.19866 8.97106 7.01463 8.78048 6.7826 8.78048H0.709728C0.557706 8.78048 0.429688 8.65342 0.429688 8.50254C0.429688 8.35167 0.557706 8.22461 0.709728 8.22461H6.7826C7.31868 8.22461 7.75874 8.66136 7.75874 9.19341C7.75874 9.72545 7.31868 10.1622 6.7826 10.1622Z"
        fill="white"
      />
    </g>
  </svg>
)

export default WindIcon
